// src/utils/fetchReviews.js
export const Config = {
 // キャッシュバスター用のタイムスタンプを定数で管理
 cacheBuster: "20250318",
};

export async function fetchReviews() {
 try {
  const response = await fetch(`/assets/data/review.json?${Config.cacheBuster}`);
  const data = await response.json();
  return data;
 } catch (error) {
  console.error("Review fetch error:", error);
  return [];
 }
}
